import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
private _loading = new BehaviorSubject<boolean>(false);
  loading$ = this._loading.asObservable();

  get isLoading() {
    return this._loading.value;
  }

  show() {
    this._loading.next(true);
  }

  hide() {
    this._loading.next(false);
  }
}
